import { ReactElement } from 'react';
import { Input, Button, Form } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { RowBlock, NoCell, DeleteButtonCell, ResultCell, FormItemNoMargin } from './Row.style';
import { BulkCreateCustomersResult } from '@minutes-system/backend/src/api/customers/schema';
import { PHONE_PATTERN } from '../../../../../shared/phonePattern';
import ResultIcon from './ResultIcon';

interface CustomerFormValue {
  name: string;
  phone: string;
  mobilePhone: string;
}

interface Props {
  fieldName: number;
  rowKey: number;
  onRemove: () => void;
  canRemove: boolean;
  result?: BulkCreateCustomersResult;
}

const Row = ({ fieldName, rowKey, onRemove, canRemove, result }: Props): ReactElement => {
  const rowNumber = fieldName + 1;
  return (
    <RowBlock>
      <NoCell>{rowNumber}</NoCell>

      <Form.Item name={[fieldName, 'rowKey']} initialValue={rowKey} hidden>
        <Input type='hidden' />
      </Form.Item>

      <FormItemNoMargin
        name={[fieldName, 'name']}
        rules={[
          { required: true, whitespace: true, message: '氏名は入力必須です。' },
          { max: 100, message: '氏名は100文字以内で入力してください' },
        ]}
      >
        <Input placeholder='氏名を入力' />
      </FormItemNoMargin>

      <FormItemNoMargin
        name={[fieldName, 'phone']}
        rules={[
          { pattern: PHONE_PATTERN, message: '10-11桁の数字で入力してください' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              const customers = (getFieldValue('customers') as CustomerFormValue[] | undefined) ?? [];
              const customer = customers[fieldName];
              if (!value && !customer?.mobilePhone) {
                return Promise.reject(new Error('固定電話番号か携帯電話番号のいずれかを入力してください'));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Input placeholder='0312345678' />
      </FormItemNoMargin>

      <FormItemNoMargin
        name={[fieldName, 'mobilePhone']}
        rules={[
          { pattern: PHONE_PATTERN, message: '10-11桁の数字で入力してください' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              const customers = (getFieldValue('customers') as CustomerFormValue[] | undefined) ?? [];
              const customer = customers[fieldName];
              if (!value && !customer?.phone) {
                return Promise.reject(new Error('固定電話番号か携帯電話番号のいずれかを入力してください'));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Input placeholder='09012345678' />
      </FormItemNoMargin>

      <DeleteButtonCell>
        <Button
          type='text'
          danger
          icon={<DeleteOutlined />}
          onClick={onRemove}
          disabled={!canRemove}
          aria-label='削除'
        />
      </DeleteButtonCell>

      <ResultCell>
        <ResultIcon result={result} />
      </ResultCell>
    </RowBlock>
  );
};

export default Row;
